import { Component, EventEmitter, inject, Input, OnDestroy, OnInit } from '@angular/core';
import { CommonModule, CurrencyPipe, DatePipe } from '@angular/common';
import { DonationsExposedService } from '../../data-access/donations-exposed.service';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { MatTableModule } from '@angular/material/table';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatIcon } from '@angular/material/icon';
import { MatButton } from '@angular/material/button';
import { AmountPipe } from '../../../payments/payment/pipes';
import { DonationsDetailDialogComponent } from '../../ui/donations-detail-dialog/donations-detail-dialog.component';
import { DonationReceiptDialogComponent } from '../../ui/donation-receipt-dialog/donation-receipt-dialog.component';
import { takeUntil } from 'rxjs';
import { SubscriptionReceiptListDialogComponent } from '../../ui/subscription-receipt-list-dialog/subscription-receipt-list-dialog.component';

@Component({
  selector: 'equine-ui-nx-donations-list',
  standalone: true,
  imports: [
    MatTableModule,
    MatPaginatorModule,
    MatIcon,
    CommonModule,
    MatButton,
    AmountPipe
  ],
  providers: [
    DonationsExposedService,
    AmountPipe,
    CurrencyPipe,
    DatePipe
  ],
  templateUrl: './donations-list.component.html',
  styleUrl: './donations-list.component.scss',
})
export class DonationsListComponent implements OnInit, OnDestroy {
  private donationsExposedService = inject(DonationsExposedService);
  public dialog = inject(MatDialog);
  private router = inject(Router);
  private amountPipe = inject(AmountPipe);
  private currencyPipe = inject(CurrencyPipe);
  private datePipe = inject(DatePipe);

  private unsubscribe$ = new EventEmitter<void>();

  @Input({ required: true }) userId!: string;

  donationsTable = [];
  displayedColumns = ['action', 'id', 'date', 'category', 'frequency', 'amount', 'receipt'];

  totalLines = 0;
  pageSizeOptions: number[] = [10, 20, 50];
  pageSize = 10;
  pageIndex = 0;

  ngOnInit() {
    this.fetchTableData();
  }

  fetchTableData() {
    this.donationsExposedService.getDonationsByUserId(this.userId, this.pageSize, this.pageIndex)
      .subscribe({
        next: (response: any) => {
          this.totalLines = response?.metadata?.count;
          this.donationsTable = response?.data;
        }
      })
  }

  onPaginationChange(paginationChange: any) {
    console.log(paginationChange)
    this.pageSize = paginationChange.pageSize;
    this.pageIndex = paginationChange.pageIndex;

    this.fetchTableData();
  }

  manageSubscription(subscription: any) {
    this.dialog.open(DonationsDetailDialogComponent, {
      data: {
        donationId: subscription.donationLogId,
        payments: subscription.payments,
        userId: this.userId,
        subscription
      }
    }).afterClosed().subscribe(() => {
      this.fetchTableData();
    })
  }

  openReceiptDialogForOngoing(subscription: any) {
    this.dialog.open(SubscriptionReceiptListDialogComponent, {
      data: {subscription}
    }).afterClosed()
    .pipe(
      takeUntil(this.unsubscribe$)
    )
    .subscribe({
      next: (serviceId: string) => {
        if (serviceId) {
          const paymentFound = subscription.payments.find((each: any) => each.serviceId === serviceId);
          this.openSimpleReceiptDialog(paymentFound);
        }
      }
    })
  }

  openSimpleReceiptDialog(payment: any) {
    this.dialog.open(DonationReceiptDialogComponent, {
      data: {
        amount: this.currencyPipe.transform(this.amountPipe.transform(payment.amount)),
        date: this.datePipe.transform(payment.timestamp)
      }
    }).afterClosed()
    .pipe(
      takeUntil(this.unsubscribe$)
    )
    .subscribe({
      next: (action: string) => {
        if (action === 'PRINT') {
          this.router.navigate(['donation', 'receiptPrint'], {queryParams: {serviceId: payment.serviceId}})
        }
      }
    })
  }

  ngOnDestroy(): void {
      this.unsubscribe$.next();
      this.unsubscribe$.complete();
  }

}
